import { render, staticRenderFns } from "./dragon-activity.vue?vue&type=template&id=1bef4882&scoped=true&"
import script from "./dragon-activity.vue?vue&type=script&lang=js&"
export * from "./dragon-activity.vue?vue&type=script&lang=js&"
import style0 from "./dragon-activity.vue?vue&type=style&index=0&id=1bef4882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef4882",
  null
  
)

export default component.exports